import "./src/css/style.css";
import "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core";
